/*
  Judge.me a11y patcher.
  Judge.me's rendered HTML has known accessibility gaps that hurt screen
  readers AND AI agents. Since the markup is injected async, we watch for
  it with a MutationObserver and patch in the missing semantics.

  Fixes:
    1. <div class="jdgm-stars" aria-label="..."> needs role="img"
       (generic divs can't carry aria-label without a role)
    2. <button class="jdgm-arrow"> needs aria-label ("Previous reviews" / "Next reviews")
    3. <img> inside .jdgm-card without alt gets alt="Customer review photo"
    4. Empty <h2 class="jdgm-title"> gets aria-hidden so screen readers
       don't announce "heading, blank"
*/

(function () {
  'use strict';

  function patchEl(el) {
    if (!el || el.nodeType !== 1) return;

    // 1. Stars: add role="img" so aria-label is valid
    if (el.classList.contains('jdgm-stars') && el.hasAttribute('aria-label') && !el.hasAttribute('role')) {
      el.setAttribute('role', 'img');
    }

    // 2. Arrow buttons: derive label from onclick handler
    if (el.tagName === 'BUTTON' && el.classList.contains('jdgm-arrow') && !el.hasAttribute('aria-label')) {
      var onclick = el.getAttribute('onclick') || '';
      if (onclick.indexOf('PreviousCard') !== -1 || onclick.indexOf('PrevCard') !== -1) {
        el.setAttribute('aria-label', 'Previous reviews');
      } else if (onclick.indexOf('NextCard') !== -1) {
        el.setAttribute('aria-label', 'Next reviews');
      } else {
        el.setAttribute('aria-label', 'Browse reviews');
      }
    }

    // 3. Review card images: default alt for any without one
    if (el.tagName === 'IMG' && !el.hasAttribute('alt') && el.closest && el.closest('.jdgm-card, .jdgm-rev__pics, .jdgm-rev')) {
      el.setAttribute('alt', 'Customer review photo');
    }

    // 4. Empty Judge.me title heading: hide from a11y tree
    if ((el.tagName === 'H2' || el.tagName === 'H3') && el.classList.contains('jdgm-title') && !el.hasAttribute('aria-hidden') && !el.textContent.trim()) {
      el.setAttribute('aria-hidden', 'true');
    }
  }

  function patchTree(root) {
    if (!root || root.nodeType !== 1) return;
    patchEl(root);
    if (root.querySelectorAll) {
      var nodes = root.querySelectorAll('.jdgm-stars, button.jdgm-arrow, .jdgm-card img, .jdgm-rev img, h2.jdgm-title, h3.jdgm-title');
      for (var i = 0; i < nodes.length; i++) patchEl(nodes[i]);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      patchTree(document.body);
    });
  }

  function init() {
    patchTree(document.body);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
